import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFSolarPanel from '@/components/UI/svg/mm100/Icon/EFSolarPanel';
import EFReplay from '@/components/UI/svg/mm100/Icon/EFReplay';
import EFVideo from '@/components/UI/EFVideo';

export default function home2() {
    const { useLang, useEffect, useRouter, useState, useRef } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    const fadeIn = (el: any) => {
        const target = document.querySelector(`.kitProduct .mm100_home2 ${el}`) as HTMLElement;
        const targetH = target?.offsetHeight || 100;

        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        scene1.setTween(tween1);
        scene1.addTo(AniContainer);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(AniContainer);
    };

    useEffect(() => {
        // 文字透明渐变 - 进入
        fadeIn('.title');
        fadeIn('.text');
        fadeIn('.iconText');
    }, []);

    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    useEffect(() => {
        // mm100_home2进入视窗渲染video
        const videoEl = document.querySelector('.kitProduct .mm100_home2') as HTMLElement;
        const scene = new ScrollMagic.Scene({
            triggerElement: videoEl,
            triggerHook: 1,
            offset: 0,
        });
        scene.on('enter', () => {
            setEnter(true);
        });
        scene.addTo(AniContainer);
    }, []);

    useEffect(() => {
        if (videoRef) {
            const videoBoxEl = document.querySelector('.mm100_home2 .videoBox') as HTMLElement;
            // 视频的一半区域进入视窗后开始播放
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.kitProduct .mm100_home2 .videoBox',
                triggerHook: 1,
                offset: videoBoxEl?.offsetHeight / 2,
            });
            scene1.on('enter', () => {
                videoRef?.current?.play();
            });
            AniContainer.addScene(scene1);
        }
    }, [videoRef]);

    // 监听视频是否播放： 播放状态下不显示replay按钮
    const [showIcon, setShowIcon] = useState(true);
    useEffect(() => {
        const playing = () => setShowIcon(false);
        videoRef?.current?.addEventListener('play', playing);
        const playEnd = () => setShowIcon(true);
        videoRef?.current?.addEventListener('ended', playEnd);

        return () => {
            videoRef?.current?.removeEventListener('ended', playEnd);
            videoRef?.current?.removeEventListener('play', playing);
        };
    }, []);

    const onReplay = () => {
        videoRef?.current?.play();
    };

    return (
        <div className={`mm100_home2 ${css.mm100_home2}`}>
            <div className="container">
                <div className="left">
                    <p className="title">{t('presale.product.home2_title')}</p>
                    <p className="text">{t('presale.product.home2_text')}</p>
                    <div className="iconText">
                        <div className="iconBox">
                            <EFSolarPanel />
                        </div>
                        <div className="textBox">
                            <p className="iconTitle">{t('presale.product.home2_sub_title')}</p>
                            <p className="iconDesc">{t('presale.product.home2_sub_desc')}</p>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="videoBox">
                        {enter && (
                            <>
                                <EFVideo
                                    ref={videoRef}
                                    className="mm100_home2_video"
                                    sources={['/video/mm100/backup.mp4', '/video/mm100/backup.webm']}
                                    width={'100%'}
                                    height={'100%'}
                                    playsInline
                                    autoPlay={false}
                                    loop={false}
                                    preload="auto"
                                    muted
                                />
                                {showIcon && (
                                    <div className="replayIcon" onClick={onReplay}>
                                        <EFReplay fillOpacity="0.6" fill="#fff" />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
